export default __webpack_public_path__ + "static/Web437_DOS-V_re_ANK24-25623f0b0a1efeab2f54b0647bbe9f9b.woff";